module.exports = __webpack_public_path__ + "img/shvarc.a18d94a8.jpg";